import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MediaStatistic from './media-statistic-model'
import {
  CreateMediaStatisticAsync,
  DeleteMediaStatisticAsync,
  LoadMediaStatisticsAsync,
} from './mediaStatistic-thunk'
const initialState: mediaStatisticSliceState = {
  mediaStatistic: [],
  selected_mediaStatistic: '',
  is_loading_mediaStatistic: false,
  is_creating_mediaStatistic: false,
  is_deleting_mediaStatistic: false,
}
export interface mediaStatisticSliceState {
  mediaStatistic: MediaStatistic[]
  selected_mediaStatistic?: string
  is_loading_mediaStatistic: boolean
  is_creating_mediaStatistic: boolean
  is_deleting_mediaStatistic: boolean
}
export const mediaStatisticSlice = createSlice({
  name: 'mediaStatistic',
  initialState,
  reducers: {
    setSelectedmediaStatistic: (state, action) => {
      state.selected_mediaStatistic = action.payload
    },
    clearStatemediaStatistic: (state) => {
      state.mediaStatistic = []
      state.is_loading_mediaStatistic = false
      state.is_creating_mediaStatistic = false
      state.is_deleting_mediaStatistic = false
    },
    mergemediaStatistic: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaStatistic = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaStatistic = merge(state.mediaStatistic, payload) as any
        }
      }
    },

    add_mediaStatistic: (state, action) => {
      if (action.payload) {
        state.mediaStatistic = [...state.mediaStatistic, action.payload]
      }
    },
    set_mediaStatistic: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaStatistic = state.mediaStatistic.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaStatisticsAsync.pending, (state) => {
      state.is_loading_mediaStatistic = true
    })
    builder.addCase(LoadMediaStatisticsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaStatistic = false
      if (action.payload) {
        state.mediaStatistic = action.payload
      }
    })
    builder.addCase(LoadMediaStatisticsAsync.rejected, (state) => {
      state.is_loading_mediaStatistic = false
    })
    builder.addCase(CreateMediaStatisticAsync.pending, (state) => {
      state.is_creating_mediaStatistic = true
    })
    builder.addCase(CreateMediaStatisticAsync.fulfilled, (state) => {
      state.is_creating_mediaStatistic = false
    })
    builder.addCase(CreateMediaStatisticAsync.rejected, (state) => {
      state.is_creating_mediaStatistic = false
    })
    builder.addCase(DeleteMediaStatisticAsync.pending, (state) => {
      state.is_deleting_mediaStatistic = true
    })
    builder.addCase(DeleteMediaStatisticAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaStatistic = false
      if (state.mediaStatistic) {
        state.mediaStatistic = state.mediaStatistic.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaStatisticAsync.rejected, (state) => {
      state.is_deleting_mediaStatistic = false
    })

    builder.addCase(autoThunks.fetch_media_statistics.pending, (state) => {
      state.is_loading_mediaStatistic = true
    })
    builder.addCase(
      autoThunks.fetch_media_statistics.fulfilled,
      (state, action) => {
        state.is_loading_mediaStatistic = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.fetch_media_statistics.rejected, (state) => {
      state.is_loading_mediaStatistic = false
    })
  },
})

function handleResult(action: any, state: mediaStatisticSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_mediaStatistic = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.mediaStatistic = merge(state.mediaStatistic, payload) as any
    }
  }
}

export const {
  clearStatemediaStatistic,
  setSelectedmediaStatistic,
  set_mediaStatistic,
  mergemediaStatistic,
  add_mediaStatistic,
} = mediaStatisticSlice.actions

export const get_mediaStatistic =
  (id?: string) =>
  (state: {
    mediaStatistic: {
      mediaStatistic: MediaStatistic[]
    }
  }): MediaStatistic | null => {
    let temp = state?.mediaStatistic?.mediaStatistic?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaStatistic?.mediaStatistic[0] || null
  }
export const get_selected_mediaStatistic = (state: {
  mediaStatistic: mediaStatisticSliceState
}): MediaStatistic | null => {
  let id = state?.mediaStatistic?.selected_mediaStatistic
  let temp = state?.mediaStatistic?.mediaStatistic?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaStatistic = (state: {
  mediaStatistic: {
    mediaStatistic: MediaStatistic[]
  }
}): MediaStatistic[] => {
  let temp = state?.mediaStatistic?.mediaStatistic
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaStatistic_busy = (state: {
  mediaStatistic: mediaStatisticSliceState
}) => {
  return (
    state?.mediaStatistic.is_deleting_mediaStatistic ||
    state?.mediaStatistic.is_loading_mediaStatistic ||
    state?.mediaStatistic.is_creating_mediaStatistic
  )
}
export const is_deleting_mediaStatistic_busy = (state: {
  mediaStatistic: mediaStatisticSliceState
}) => {
  return state?.mediaStatistic.is_deleting_mediaStatistic
}
export const is_loading_mediaStatistic_busy = (state: {
  mediaStatistic: mediaStatisticSliceState
}) => {
  return state?.mediaStatistic.is_loading_mediaStatistic
}
export const is_creating_mediaStatistic_busy = (state: {
  mediaStatistic: mediaStatisticSliceState
}) => {
  return state?.mediaStatistic.is_creating_mediaStatistic
}

export default mediaStatisticSlice.reducer
